var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('information-card',{attrs:{"title":_vm.title,"sub-title":_vm.subtitle}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._t("content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31b10b13","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/job-profile/components/content/model-description.vue
// module id = 1466
// module chunks = 12 13 14 16 19 24 25 28 30 31 32 33 34 35 40 42